/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-08-15 14:49:03
 * @Description  : 初始化pinia,需要在客户端获取完信息之后才调用
 */
import { createPinia } from '@ywxk/pinia/createPinia';
import { constConf } from '@GLOBAL/constConf';
import { appData } from '@GLOBAL/bridge';
import { picAnalysis } from '@UTILS/pic';
import { client } from '@UTILS/client';

export function initPinia() {
  createPinia({
    picAnalysis, // url处理函数
    actId: constConf.ACT_ID, // 活动id
    client, // 平台判断对象
    appPlayerId: appData?.id ?? 0, // 用户id
    isReqApp: appData?.canAsyncReq, // 是否从客户端获取配置
  })
};

